import { render, staticRenderFns } from "./MessageDeleted.vue?vue&type=template&id=2514382e&"
import script from "./MessageDeleted.vue?vue&type=script&lang=js&"
export * from "./MessageDeleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports